import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type VerifyLocalizedContentMutationVariables = Types.Exact<{
  data: Types.VerifyLocalizedContentChangesInput;
}>;


export type VerifyLocalizedContentMutation = { verifyLocalizedContent: { success?: boolean | null } };


export const VerifyLocalizedContentDocument = /*#__PURE__*/ gql`
    mutation verifyLocalizedContent($data: VerifyLocalizedContentChangesInput!) {
  verifyLocalizedContent(data: $data) {
    success
  }
}
    `;

export function useVerifyLocalizedContentMutation() {
  return Urql.useMutation<VerifyLocalizedContentMutation, VerifyLocalizedContentMutationVariables>(VerifyLocalizedContentDocument);
};